const style = (theme) => ({
  text: {
    extend: theme.typography.text,
    padding: 0,
    marginBottom: 100,
    [theme.mq.md]: {
      marginBottom: 50,
      padding: '40px 60px 0',
      maxWidth: 'none',
      fontSize: 18,
    },
  },
  textDark: {
    color: theme.colors[1],
    '& h1, h2, h3, h4, h4, h5, h6, p': {
      color: theme.colors[1],
    },
  },
})

export default style
